import * as React from "react";

export interface EntriesProps {
  children: JSX.Element;
  initValues: Array<number | { id: string | number }>;
  onAddCheckedCheckbox?: (item: number) => void;
  onRemoveCheckedCheckbox?: (item: number) => void;
}

export type EntriesContextValue = {
  addCheckedCheckbox: (item: number) => boolean;
  removeCheckedCheckbox: (item: number) => void;
  addAndremoveCheckedCheckbox: (itemToRemove: number, item: number) => boolean;
  getList: () => Array<number>;
};

export const EntriesContext = React.createContext<EntriesContextValue | null>(null);

const Entries: React.FunctionComponent<EntriesProps> = ({
  children,
  initValues,
  onAddCheckedCheckbox,
  onRemoveCheckedCheckbox,
  
}) => {
  const [checkedCheckboxes, setCheckedCheckboxes] = React.useState<Array<number>>(
    () => (initValues ?? []).map((item) => Number(typeof item === 'number' ? item : item.id)).filter((item) => !Number.isNaN(item))
  );
  const addCheckedCheckbox = React.useCallback(
    (item: number) => {
      if (!checkedCheckboxes.includes(item)) {
        const newCheckedCheckboxes = [...checkedCheckboxes, item];
        setCheckedCheckboxes(newCheckedCheckboxes);
        onAddCheckedCheckbox?.(item); // Appelle la callback si elle est définie
        return newCheckedCheckboxes.length >= 3;
      }
      onAddCheckedCheckbox?.(item);
      return false;
    },
    [checkedCheckboxes, onAddCheckedCheckbox]
  );

  const removeCheckedCheckbox = React.useCallback(
    (item: number) => {
      if (checkedCheckboxes.includes(item)) {
        const newCheckedCheckboxes = checkedCheckboxes.filter((checkbox) => checkbox !== item);
        setCheckedCheckboxes(newCheckedCheckboxes);
         // Appelle la callback si elle est définie
      }
      onRemoveCheckedCheckbox?.(item);
    },
    [checkedCheckboxes, onRemoveCheckedCheckbox]
  );

  const addAndremoveCheckedCheckbox = React.useCallback(
    (itemToRemove: number,item: number) => {
      let newCheckedCheckboxes = checkedCheckboxes;
      if (checkedCheckboxes.includes(itemToRemove)) {
        newCheckedCheckboxes = checkedCheckboxes.filter((checkbox) => checkbox !== itemToRemove);
  
      }
      onRemoveCheckedCheckbox?.(itemToRemove);
      if (!newCheckedCheckboxes.includes(item)) {
        newCheckedCheckboxes = [...newCheckedCheckboxes, item];
        setCheckedCheckboxes(newCheckedCheckboxes);
        onAddCheckedCheckbox?.(item); // Appelle la callback si elle est définie
        return newCheckedCheckboxes.length >= 3;
      }
      onAddCheckedCheckbox?.(item);
      return false;
    },
    [checkedCheckboxes, onAddCheckedCheckbox, onRemoveCheckedCheckbox]
  );

  
  const getList = React.useCallback(() => checkedCheckboxes, [checkedCheckboxes]);

  return (
    <EntriesContext.Provider
      value={{
        addCheckedCheckbox,
        removeCheckedCheckbox,
        addAndremoveCheckedCheckbox,
        getList,
      }}
    >
      {children}
    </EntriesContext.Provider>
  );
};

export default Entries;
